import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import { I as InputFormGroup } from '../InputFormGroup/InputFormGroup-78a403a4.js';
import { g as getCurrencySymbol } from './getCurrencySymbol-fd463464.js';
import { g as getCurrencyPosition } from './getCurrencyPosition-6b5f104c.js';
import { p as parseIetfLanguageTag } from './parseIetfLanguageTag-edc8174b.js';

class CurrencyInput extends PureComponent {
  render() {
    const {
      id,
      currency,
      locale,
      type,
      ariaLabel,
      ...rest
    } = this.props;
    if (!currency || !locale) {
      return /*#__PURE__*/React__default.createElement(InputFormGroup, _extends({}, rest, {
        id: id,
        type: type,
        ariaLabel: ariaLabel
      }));
    }
    let currencySymbol;
    let currencyPosition;
    if (typeof Intl !== 'undefined') {
      var _Intl$NumberFormat;
      const parts = (_Intl$NumberFormat = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency
      })) === null || _Intl$NumberFormat === void 0 ? void 0 : _Intl$NumberFormat.formatToParts(0);
      if (parts && parts.length) {
        var _parts;
        currencyPosition = 'prefix';
        currencySymbol = parts[0].value;
        if (((_parts = parts[parts.length - 1]) === null || _parts === void 0 ? void 0 : _parts.type) === 'currency') {
          var _parts2;
          currencySymbol = (_parts2 = parts[parts.length - 1]) === null || _parts2 === void 0 ? void 0 : _parts2.value;
          currencyPosition = 'suffix';
        }
      }
    }

    // Since the AdsConsole does not have en-ZA as a locale, we must force 'ZAR' to map to 'R'. The above code
    // block resolves all other 'en-*' locales to ZAR.
    if (!currencySymbol || currencySymbol === 'ZAR') {
      const {
        language,
        country
      } = parseIetfLanguageTag(locale);
      currencySymbol = getCurrencySymbol(currency);
      currencyPosition = getCurrencyPosition(language, country);
    }
    let prefix = null;
    let suffix = null;
    if (currencySymbol && currencyPosition) {
      if (currencyPosition === 'prefix') {
        prefix = currencySymbol;
      } else {
        suffix = currencySymbol;
      }
    }
    return /*#__PURE__*/React__default.createElement(InputFormGroup, _extends({}, rest, {
      id: id,
      type: type,
      prefix: prefix,
      suffix: suffix,
      ariaLabel: ariaLabel || `enter amount in ${currencySymbol}`,
      ignoreTextDirection: true
    }));
  }
}
_defineProperty(CurrencyInput, "propTypes", {
  /**
   * The id attribute that is supplied to the input element.
   */
  id: PT.string.isRequired,
  /**
   * Displays the appropriate currency symbol based on currency (USD, EUR, etc..).
   */
  currency: PT.string,
  /**
   * Positions the currency symbol based on locale (en, fr, en-US, fr-US, etc...).
   */
  locale: PT.string,
  type: PT.string,
  /**
   * Set custom aria-label attribute on input.
   */
  ariaLabel: PT.string
});
_defineProperty(CurrencyInput, "defaultProps", {
  type: 'number',
  ariaLabel: undefined,
  currency: undefined,
  locale: undefined
});

export { CurrencyInput as C };
//# sourceMappingURL=CurrencyInput-794108a4.js.map
